
angular.module('bmsApp.directives').factory('NoteSvc', [
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'NOTE_API', function (
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		NOTE_API) {

	return {
		noteTypeOptions: function () {
			return CRUDSvc.get(NOTE_API.NOTE_TYPE_OPTIONS);
		},
		indexByObject: function (params) {
			return CRUDSvc.post(NOTE_API.INDEX_BY_OBJECT, params);
		},
		create: function (note) {
			return CRUDSvc.post(NOTE_API.CREATE, note);
		},
		update: function (note) {
			return CRUDSvc.post(NOTE_API.UPDATE + note.id, note);
		},
		delete: function (note) {
			return CRUDSvc.get(NOTE_API.DELETE + note.id);
		},
		showSaveModal: function (note) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/notes/templates/NoteForm.html',
				controller: 'NoteFormCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					note: function () {
						return angular.copy(note);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					var message;
					switch (result.action) {
						case 'create':
							message = 'Note created successfully';
							break;
						case 'update':
							message = 'Note updated successfully';
							break;
						default:
							message = 'Success';
							break;
					}
					notify({
						message: message
					});
					$rootScope.$broadcast('notesUpdated');
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});
		}
	};

}]).constant('NOTE_API', {
	NOTE_TYPE_OPTIONS: 'api/noteType/options',
	INDEX_BY_OBJECT: 'api/note/indexByObject',
	CREATE: 'api/note/create',
	UPDATE: 'api/note/update/',
	DELETE: 'api/note/delete/'
});
